import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import CfiRoutingControl from '../../../features/distributor/cfi-routing/components/CfiRoutingControl';

export default function CfiRoutingPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('CFI Routing')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<CfiRoutingControl />
			</div>
		</React.Fragment>
	)
} 
